import {
  FETCH_CIC_CATEGORIES_SUCCESS,
} from './actions';
import Category from './model';
import { Map } from 'immutable';


export default function CICCategories(state = new Map({}), action) {
  switch (action.type) {
    case FETCH_CIC_CATEGORIES_SUCCESS:
      return state.set(action.groupId, onSuccess(action));
    default:
      return state;
  }
}

function onSuccess({ payload }) {
  return payload.map((category) => new Category(category));
}



// WEBPACK FOOTER //
// ./data/CoveredInClass/CategoryTemplate/reducer.js